import {
  Button,
  Card,
  Switch,
  Table,
  Tooltip,
  Form,
  Input,
  Modal,
  Row,
  Col,
  DatePicker,
  Image,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { useNavigate } from "react-router";
import { APIServices } from "../../services/AuthAPIs";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import notfound from "../../assets/images/not_found.png";

const { RangePicker } = DatePicker;

function Index() {
  const heading = lang("Feed") + " " + lang("Manager");
  const { setPageHeading } = useContext(AppStateContext);
  const Search = Input.Search;
  const sectionName = lang("Feed");
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");
  const { getData, deleteData } = APIServices();

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([
    {
      _id: 1,
      title: "Romaing in Rome",
      location: "Rome",
      description: "Rome is great to visit, visit once.",
      image: "",
      tags: [],
      user_id: { name: "Yogesh" },
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const navigate = useNavigate();

  const columns = [
    {
      title: "src",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => (
        <Image
          width={50}
          src={image.length ? image?.[0] : notfound}
          className="table-img"
        />
      ),
    },
    {
      title: "caption",
      dataIndex: "caption",
      key: "caption",
      width: 200,
      sorter: (a, b) => a?.caption?.localeCompare(b?.caption),
      render: (_, { caption }) => {
        return caption ? caption : "-";
      },
    },
    {
      title: "Post By",
      dataIndex: "user",
      key: "user",
      sorter: (a, b) => a.user_id?.name?.localeCompare(b?.user_id?.name),
      render: (_, { user_id }) => {
        return user_id ? (
          <div className="posed-by_--emaill">
            <p>{user_id?.name}</p>
            <p> {user_id?.email}</p>
          </div>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Likes",
      dataIndex: "likes",
      key: "likes",
      render: (_, { likes }) => {
        return likes?.length ? likes?.length : "0";
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (_, { comments }) => {
        return comments?.length ? comments?.length : "0";
      },
    },
    {
      title: "Is Reported",
      dataIndex: "is_reported",
      key: "is_reported",
      render: (_, { is_reported, _id }) => {
        return <Switch
          onChange={() => {
            handleChangeStatus(_id);
          }}
          checked={is_reported}
        />;
      },
    },
    {
      title: "Posted On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip
              title={"view"}
              color={"purple"}
              key={"view"}
              className="main-second-classforedit-5"
            >
              <Button
                title={"view"}
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                  navigate(`/feed/view/${record._id}`, {
                    state: { data: record },
                  });
                }}
              >
                <EyeOutlined />
              </Button>
            </Tooltip>
            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i
                  style={{ fontSize: "small", color: "fff" }}
                  class="fa fa-light fa-trash"
                ></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleChangeStatus = (id, message) => {
    request({
      url: apiPath.reportFeed + id,
      method: "PUT",
      data: { message },
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ ...pagination, current: 1 });
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : null;

    request({
      url:
        apiPath.getFeeds +
        `?status=${filterActive ? filterActive.join(",") : ""}&page=${pagination ? pagination.current : 1
        }&pageSize=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}${path ? `&status=1` : ""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(data.data);
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data?.total,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData({ ...pagination, current: 1 });
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"User Feeds"}
              extra={
                <>
                  <div className="button_group justify-content-end w-100">
                    <Search
                      allowClear
                      className="search-input"
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Caption, Post By"
                      title="Search By Caption, Post By"
                    />
                    <RangePicker
                      disabledDate={(current) => current.isAfter(Date.now())}
                      onChange={handleChangeDate}
                    />
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {showDelete && (
        <DeleteModal
          title={lang("Delete Feed")}
          subtitle={lang(`Are you sure you want to delete this feed?`)}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() =>
            deleteData(
              apiPath.deleteFeed,
              selected?._id,
              setLoading,
              setRefresh
            )
          }
        />
      )}
    </>
  );
}

export default Index;
